import localforage from 'localforage';

export const DB_NAME = 'osp';

class LocalforageStore {
  constructor(storeName) {
    this.instance = localforage.createInstance({
      name: DB_NAME,
      storeName,
    });
    this.name = storeName;
  }

  async getItems() {
    const items = {};

    await this.instance.iterate((value, key) => {
      items[key] = value;
    });

    return items;
  }

  async setItem(key, item) {
    return this.instance.setItem(key, item);
  }

  async clear() {
    return this.instance.clear();
  }
}

export default LocalforageStore;
